// Pull requests to other people's open-source projects.
// While this array is empty, the Contributions section and its nav shortcut are not rendered,
// so this file is safe to merge before the first contribution exists.
//
// Mirror of the table in github.com/Bat0oo/open-source-contributions. When you add a row there, add it here too
// (only if it's worth showing off; the site shows the 3 newest entries).
//
// type:   'fix' | 'feat' | 'docs' | 'perf' | 'test' | 'refactor' | 'chore'
// status: 'merged' | 'open' | 'closed'
// date:   'YYYY-MM' (month the PR was merged, or opened if not merged yet)
// writeup (optional): link to the detail .md in the contributions repo
//
// Example entry (copy, fill in):
// {
//   id: 'rails-12345',
//   type: 'fix',
//   project: { name: 'Rails', url: 'https://github.com/rails/rails' },
//   stack: ['Ruby', 'Rails'],
//   title: 'Fix X when Y',
//   summary: {
//     en: 'One sentence: what was broken and what the fix changed.',
//     sr: 'Jedna rečenica: šta nije radilo i šta je izmjena promijenila.'
//   },
//   pr: 'https://github.com/rails/rails/pull/12345',
//   status: 'merged',
//   date: '2026-11',
//   writeup: 'https://github.com/Bat0oo/open-source-contributions/blob/main/contributions/2026-11-rails-fix-x.md'
// },

export const contributions = [
    {
    id: 'stryker-net-3939',
    type: 'fix',
    project: { name: 'Stryker.NET', url: 'https://github.com/stryker-mutator/stryker-net' },
    stack: ['C#', '.NET'],
    title: 'Print report URI after uploading the final dashboard report',
    summary: {
      en: 'Without real-time reporting, Stryker uploaded the final mutation report to the dashboard but never showed its link. The upload now returns the report URI and Stryker prints it, without duplicating the link in real-time mode. Covered by new unit tests.',
      sr: 'Bez real-time izvještavanja, Stryker je slao finalni izvještaj na dashboard, ali nikad nije prikazao njegov link. Upload sada vraća URI izvještaja i Stryker ga ispisuje, bez dupliranja linka u real-time režimu. Pokriveno novim unit testovima.'
    },
    pr: 'https://github.com/stryker-mutator/stryker-net/pull/3939',
    status: 'merged',
    date: '2026-11',
    writeup: 'https://github.com/Bat0oo/open-source-contributions/blob/main/contributions/2026-11-stryker-net-dashboard-report-uri.md'
  },
  {
    id: 'annotaterb-413',
    type: 'fix',
    project: { name: 'annotaterb', url: 'https://github.com/drwl/annotaterb' },
    stack: ['Ruby', 'Rails'],
    title: 'Set default tenant for activerecord-tenanted models',
    summary: {
      en: 'annotaterb crashed in Rails apps using activerecord-tenanted because no tenant was selected at boot; the fix runs the gem\'s own tenant task first.',
      sr: 'annotaterb se rušio u Rails aplikacijama sa activerecord-tenanted jer pri pokretanju nije bio izabran tenant; izmjena prvo pokreće tenant task tog gema.'
    },
    pr: 'https://github.com/drwl/annotaterb/pull/413',
    status: 'merged',
    date: '2026-10',
    writeup: 'https://github.com/Bat0oo/open-source-contributions/blob/main/contributions/2026-10-annotaterb-activerecord-tenanted.md'
  },
  {
    id: 'featbit-1017',
    type: 'docs',
    project: { name: 'FeatBit', url: 'https://github.com/featbit/featbit' },
    stack: ['C#', 'ASP.NET Core'],
    title: 'Clarify segment scopes requirements in OpenAPI',
    summary: {
      en: 'The API reference showed segment scopes as optional, while the API rejected requests without them; documented the real contract and made it required in the schema.',
      sr: 'API dokumentacija je prikazivala scopes segmenta kao opcione, a API je odbijao zahtjeve bez njih; dokumentovan je stvarni ugovor i polje je označeno kao obavezno u šemi.'
    },
    pr: 'https://github.com/featbit/featbit/pull/1017',
    status: 'merged',
    date: '2026-10',
    writeup: 'https://github.com/Bat0oo/open-source-contributions/blob/main/contributions/2026-10-featbit-segment-scopes-openapi.md'
  }
];

export default contributions;
